import React, { Component } from "react";

import { isMobile } from "../../utils/deviceInfo";
import "../../pages/trivia/trivia-survey.css";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Popover,
  PopoverBody,
} from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import axios from "../../axios";
import * as url from "../../utils/url";
import * as actionCreators from "../../modules/actions/index";
import Loading from "../../hoc/Loading/Loading";

import {
  LayoutHeadingShadow,
  LayoutRowShadow,
  LayoutData,
  LayoutHeadingShadowLeft,
} from "../../components/TableComponents/RowCardShadow/RowCardShadow";

import { getObjectForShareMessageResult } from "../../pages/trivia/data.js";
import { BsThreeDots } from "react-icons/bs";
import { BiUpArrowAlt, BiDownArrowAlt } from "react-icons/bi";

import EmptyTable from "../../components/EmptyTable/EmptyTable";
import { baseUrl } from "../../utils/constants";
import MessagingSurvey from "../../pages/trivia/Quiz/MessaginSurvey";
import ShareEntity from "../../components/ShareEntity/ShareEntity";
import { orderBy } from "lodash";

class TriviaList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mySubmittedQuizes: [],
      detailsModalOpen: false,
      detailsModalData: null,
      optionsPopover: null,
      shareClickOpen: false,
      customModalText: null,
      sortBy: "",
      sortOrder: "",
    };
  }

  openDetailsModal = (data) => {
    this.props.setCurrentQuizData(data.triviaId);
    this.setState({
      detailsModalData: data,
      detailsModalOpen: true,
    });
  };

  closeDetailsModal = () => {
    this.setState({
      detailsModalData: null,
      detailsModalOpen: false,
    });
  };

  componentDidMount() {
    if (isMobile) {
      this.props.updateNavBar({
        title: "Trivvy",
        hasBack: true,
        backButton: "<b>Back</b>",
        showNotification: true,
        className: null,
        isBreadCrumbs: false,
      });
    }

    this.retrieveMySubmittedQuizes();
    this.props.setCurrentTrivia(null);
  }

  handleTakeTrivvy = (trivia) => {
    this.props.history.push(
      `/home/trivia/${trivia.organizationId}/quiz/${trivia._id}/start`
    );
  };

  retrieveMySubmittedQuizes = () => {
    axios
      .post(url.getMyRespondedMessages, { fetchLatest: true })
      .then(({ data }) => {
        const params = new URLSearchParams(window.location.search);
        const docId = params.get("myDocId");
        const pendingCount = data.data.filter((e) => e.isPending).length || "";
        this.props.updateProfileInfoSuccess({
          pendingMessagesCount: pendingCount,
        });

        if (docId) {
          const doc = data.data.find((x) => x._id == docId);
          if (doc) {
            this.setState({
              detailsModalOpen: true,
              detailsModalData: doc,
            });
          }
        }

        const uniqueData = data.data.reduce((acc, current) => {
          const existing = acc.find(item => item.triviaId._id === current.triviaId._id);
          if (!existing) {
            acc.push(current);
          } else if (new Date(current.quizSubmittedAt) < new Date(existing.quizSubmittedAt)) {
            const index = acc.indexOf(existing);
            acc[index] = current;
          }
          return acc;
        }, []);

        this.setState({ mySubmittedQuizes: uniqueData }, () => {
          console.log(data.data, "data is her");
          const { sortBy, sortOrder } = this.state;
          console.log(sortBy, sortOrder, "sortBy, sortOrder");
          if (sortBy && sortOrder) this.handleSortChange(sortBy, sortOrder);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // --- sorting helpers (added back) ---
  changeSortField = (key, order) => {
    this.setState({ sortBy: key, sortOrder: order }, () => {
      this.handleSortChange(key, order);
    });
  };

  handleSortChange = (key, order) => {
    let surveys = [...this.state.mySubmittedQuizes];

    console.log(key, order, "key, order");

    switch (key) {
      case "name":
        surveys = orderBy(
          surveys,
          (itm) => (itm.triviaMeta.name || "").toLowerCase(),
          [order]
        );
        break;
      case "takenOn":
        surveys = orderBy(surveys, (itm) => itm.quizSubmittedAt, [order]);
        break;
      case "Message":
        surveys = orderBy(surveys, (itm) => itm.messagingResponse.text, [
          order,
        ]);
        break;
      default:
        break;
    }

    this.setState({ mySubmittedQuizes: surveys });
  };

  sortComponent = (key) => {
    const { sortBy, sortOrder } = this.state;

    if (sortBy === key) {
      if (sortOrder === "desc") {
        return (
          <BiDownArrowAlt
            size={"13px"}
            onClick={() => this.changeSortField(key, "asc")}
            className="cursor-pointer trivia-list-sort-arrow-pos"
          />
        );
      } else {
        return (
          <BiUpArrowAlt
            size={"13px"}
            onClick={() => this.changeSortField(key, "desc")}
            className="cursor-pointer trivia-list-sort-arrow-pos"
          />
        );
      }
    } else {
      return (
        <BiUpArrowAlt
          size={"13px"}
          onClick={() => this.changeSortField(key, "desc")}
          className="cursor-pointer trivia-list-sort-arrow-pos"
        />
      );
    }
  };
  // --- end sorting helpers ---

  renderRetakeButton = (item) => {
    if (item.allowAttempts && item.allowAttempts > 0) {
      if (item.allowAttempts === 1) {
        return !(item.attemptNumber >= item.numberOfAttemptsAlllowed);
      } else if (item.allowAttempts === 2) {
        if (
          item.minimumPassingPercent &&
          item.percentCorrect >= item.minimumPassingPercent
        ) {
          return false;
        } else {
          return true;
        }
      }
    }
    return false;
  };

  renderRowOptions = (item) => {
    const { optionsPopover } = this.state;
    console.log(item, "item");

    return (
      <div>
        <span
          id={`surveyResultRow_${item._id}`}
          onClick={() => this.setState({ optionsPopover: item._id })}
          className="cursor-pointer"
        >
          <BsThreeDots />
        </span>
        <Popover
          isOpen={item._id == optionsPopover}
          target={`surveyResultRow_${item._id}`}
          toggle={() => {
            if (this.state.shareClickOpen) {
              this.setState({ shareClickOpen: false });
            } else {
              this.setState({ optionsPopover: null });
            }
          }}
          placement="bottom"
          hideArrow
          className="surveyListRow_Popover"
        >
          <PopoverBody>
            <div
              className="dropdown-item my-1 cursor-pointer"
              onClick={() => {
                this.openDetailsModal(item);
                this.setState({
                  optionsPopover: null,
                  shareClickOpen: false,
                });
              }}
            >
              View
            </div>
            {/* <div
              className="dropdown-item my-1 cursor-pointer"
              onClick={(e) => {
                this.handleTakeTrivvy(item.triviaId._id);
              }}
            >
              Submit Response
            </div> */}

            {item.librarySummaryText ? (
              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={() => {
                  this.setState({
                    optionsPopover: null,
                    shareClickOpen: false,
                    customModalText: item.librarySummaryText,
                  });
                }}
              >
                View summary
              </div>
            ) : null}

            <div
              className="dropdown-item my-1 cursor-pointer"
              onClick={() => {
                this.setState({ shareClickOpen: true });
              }}
            >
              <ShareEntity
                customClass="p-0"
                pooverUIMobileBorderClass={"border"}
                comp={<span>Share</span>}
                col
                isTiny
                customTinyPositions={["bottom", "left"]}
                user={this.props.user}
                entityType="TRIVVY"
                display="POPPER"
                item={{
                  ...getObjectForShareMessageResult(item),
                  triviaLink: `${baseUrl()}home/trivia/${
                    item.triviaId.organizationId
                  }/quiz/${item.triviaId._id}/start`,
                }}
              />
            </div>

            {this.renderRetakeButton(item) && (
              <div
                className="dropdown-item my-1 cursor-pointer"
                onClick={() =>
                  window.open(
                    `${baseUrl()}home/trivia/${item.triviaOrgid}/quiz/${
                      item.triviaId
                    }/start`
                  )
                }
              >
                Retake
              </div>
            )}
          </PopoverBody>
        </Popover>
      </div>
    );
  };

  tableUI = (quizes) => {
    return (
      <div>
        {quizes.length === 0 ? (
          <div className="d-flex justify-content-center">
            <EmptyTable
              title={"No Messages Responded Yet"}
              subtitle={"You havent responded to any messages yet."}
            />
          </div>
        ) : (
          <div className="trivia_survey_list_table px-3">
            <div className="my-4 trivia_survey_list_table_contents">
              <LayoutRowShadow className="row-shadow-header-no-shadow">
                <LayoutHeadingShadowLeft className="text-left" colWidth={3}>
                  Name {this.sortComponent("name")}
                </LayoutHeadingShadowLeft>
                <LayoutHeadingShadow
                  className={"justify-content-center"}
                  colWidth={3}
                >
                  Message {this.sortComponent("messagingResponse")}
                </LayoutHeadingShadow>
                <LayoutHeadingShadow
                  className={"justify-content-center"}
                  colWidth={4}
                >
                  Created {this.sortComponent("takenOn")}
                </LayoutHeadingShadow>
              </LayoutRowShadow>

              <div className="trivia_survey_list_table_contents_scroll">
                {quizes.map((item, idx) => {
                  const itm_color = idx % 2 === 0 ? "#ff6233" : "#c6ffe7";
                  return (
                    <LayoutRowShadow key={item._id || idx}>
                      <LayoutData colWidth={4} className="cursor-pointer px-3">
                        <div
                          className="d-flex align-items-center"
                          onClick={() => this.openDetailsModal(item)}
                        >
                          <span
                            className="trivia-list-item-color-chip"
                            style={{ backgroundColor: itm_color }}
                          />
                          <span
                            className="survey-item-title"
                            style={{ display: "block" }}
                          >
                            {item.triviaId.name}
                          </span>
                        </div>
                      </LayoutData>

                      <LayoutData colWidth={4} className="px-3">
                        <div className="d-flex align-items-center justify-content-between">
                          <span className="font-13px">
                            {item.triviaId.messagingSubject
                              ? item.triviaId.messagingSubject.length > 10
                                ? `${item.triviaId.messagingSubject.slice(
                                    0,
                                    10
                                  )}...`
                                : item.triviaId.messagingSubject
                              : ""}
                          </span>
                        </div>
                      </LayoutData>
                      <LayoutData colWidth={4} className="px-3">
                        <div className="d-flex align-items-center justify-content-between">
                          <span className="font-13px">
                            {moment(item.createdOn).format(
                              "h:mma on MMM D, YYYY"
                            )}
                          </span>
                          {/* three dots at the last place in the row */}
                          {this.renderRowOptions(item)}
                        </div>
                      </LayoutData>
                    </LayoutRowShadow>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  render() {
    const {
      mySubmittedQuizes,
      detailsModalData,
      detailsModalOpen,
      customModalText,
    } = this.state;

    return (
      <div className="my-trivia-page">
        {detailsModalData && detailsModalOpen && (
          <Modal isOpen={detailsModalOpen} className="messaging-survey-modal" size="xl">
            <ModalHeader className="trivia_modal_header_bg" toggle={this.closeDetailsModal}>
              {(detailsModalData && detailsModalData.triviaId && detailsModalData.triviaId.name) || "Messaging Survey"}
            </ModalHeader>
            <ModalBody style={{ backgroundColor: 'rgb(253, 236, 232)', color: 'rgb(255, 98, 51)' }}>
              <MessagingSurvey
                isOpenQuiz={false}
                orgId={detailsModalData && detailsModalData.triviaId && detailsModalData.triviaId.organizationId}
                quizData={detailsModalData && detailsModalData.triviaId}
                quizExternalUserData={null}
              />
            </ModalBody>
          </Modal>
        )}

        {customModalText && (
          <Modal isOpen={true}>
            <ModalHeader
              toggle={() => {
                this.setState({ customModalText: null });
              }}
              className="trivia_modal_header_bg"
            >
              Summary
            </ModalHeader>
            <ModalBody>{customModalText}</ModalBody>
          </Modal>
        )}

        {this.tableUI(mySubmittedQuizes)}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    setCurrentTrivia: (data) => dispatch(actionCreators.setCurrentTrivia(data)),
    updateProfileInfoSuccess: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    setCurrentQuizData: (data) => dispatch(actionCreators.setCurrentQuiz(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(TriviaList, axios));
